module.exports = __webpack_public_path__ + "static/img/jchb1-3.304baba.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-3.png
// module id = 761
// module chunks = 0